export function newAuthorizedRowKey(): string {
  return `authorized-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`
}

/**
 * Row keys stay with the same box when a row is added or removed.
 * A restore that only fills an existing row keeps that row's key.
 */
export function rowKeysForChange(
  keys: readonly string[],
  listLength: number,
  change: 'add' | 'remove' | 'restore',
  index?: number,
): string[] {
  const aligned =
    keys.length === listLength ? [...keys] : Array.from({ length: listLength }, () => newAuthorizedRowKey())
  if (change === 'remove') {
    return aligned.filter((_, itemIndex) => itemIndex !== index)
  }
  if (change === 'add' || change === 'restore') {
    return [...aligned, newAuthorizedRowKey()]
  }
  return aligned
}

/**
 * A missing or empty stored list means the tenant did not submit a separate
 * authorization list. The accounts already on the registration are the list
 * to show and edit, so add or restore does not start from nothing.
 */
export function resolveAuthorizedAccountNumbers(
  stored: readonly string[] | null | undefined,
  invitationNumbers: readonly string[],
): string[] {
  if (stored == null || stored.length === 0) {
    return invitationNumbers.filter((number) => number.trim() !== '')
  }
  return [...stored]
}

/**
 * Save sends the list only when the admin changed it. An unchanged list is left
 * off the request so the stored list (or the lack of one) stays as it is.
 */
export function authorizedAccountNumbersChanged(
  current: readonly string[] | null | undefined,
  initial: readonly string[] | null | undefined,
): boolean {
  const currentNumbers = (current ?? []).map((number) => number.trim())
  const initialNumbers = (initial ?? []).map((number) => number.trim())
  return (
    currentNumbers.length !== initialNumbers.length ||
    currentNumbers.some((number, index) => number !== initialNumbers[index])
  )
}
